<template>
  <div>
    <b-tabs>
      <b-tab title="Embarkation">
        <Embark />
      </b-tab>
      <b-tab title="Debarkation">
        <Debark/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Embark from './Embark.vue';
import Debark from './Debark.vue';

export default {
  components: {
    Embark,
    Debark
  },
};
</script>
